import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { Representative } from './representative';

@JsonObject('RepresentativeSearchResults')
export class RepresentativeSearchResults extends SearchResults {
    @JsonProperty('results', [Representative])
    results: Representative[] = [];
}
